import React from 'react';
import Textarea from '../../components/Forms/Textarea';
import Checkbox from '../../components/Forms/Checkbox';
import MetaTitle from '../../components/MetaTitle';
import convertDate from '../../utils/convertDate';
import Input from '../../components/Forms/Input';
import useFetch from '../../hooks/useFetch';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import api from '../../services/api';
import * as moment from 'moment';
import { Animation, Button, Status } from '../../assets/global/globalStyles';
import { ContainerModal, Form, Title, ButtonContent } from './styles';
import { reasonForm } from '../../utils/formVerifications';
import { fetchOrders } from '../../store/orders';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPopup } from '../../store/popup';
import { WAREHOUSE_GROUPS } from '../../global/variables/userGroups';

export default function Orders() {
  const [toggle, setToggle] = React.useState(false);
  const [order, setOrder] = React.useState(null);
  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const { data: orders } = useFetch(
    fetchOrders({
      url: '/deliveryorder/delivery-orders',
      method: 'GET',
    }),
    'orders',
  );
  const navigate = useNavigate();

  const test = () => {
    return user?.userGroup?.find(userGroup => {
      return WAREHOUSE_GROUPS.includes(userGroup)
    })
  }

  const dataUpdateObject = React.useMemo(() => {
    const orderType = {
      AAA: 'Pedido Recebido',
      CBA: 'Pedido em Separação',
      CBB: 'Pedido em Conferência',
      CCC: 'Pedido em Trânsito',
      APP: 'Pedido Entregue',
    };
    return orders.map((item) => ({
      ...item,
      deliveredDate:
        item.deliveredDate === '1900-01-01T00:00:00' ||
        item.deliveredDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveredDate, false),
      _deliveredDate:
        item.deliveredDate === '1900-01-01T00:00:00' ||
        item.deliveredDate === '0001-01-01T00:00:00'
          ? null
          : item.deliveredDate,
      deliveryDate:
        item.deliveryDate === '1900-01-01T00:00:00' ||
        item.deliveryDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveryDate, false),
      _deliveryDate:
        item.deliveryDate === '1900-01-01T00:00:00' ||
        item.deliveryDate === '0001-01-01T00:00:00'
          ? null
          : item.deliveryDate,
      _: orderType[item.orderStatus],
    }));
  }, [orders]);

  const seeOrder = ({ warehouseId, document, orderStatus, licensePlate }) => {
    navigate(
      `/dashboard/orderstatus?document=${document}&warehouseId=${warehouseId}&orderStatus=${orderStatus}&licensePlate=${licensePlate}`,
    );
  };

  const editDelivery = (data) => {
    setToggle(!toggle);
    setOrder({
      ...data,
      deliveryDate: moment(data._deliveryDate).format('YYYY-MM-DD'),
      deliveredDate: moment(data._deliveredDate).format('YYYY-MM-DD'),
    });
  };

  const closeModal = () => {
    setToggle(!toggle);
    setOrder(null);
  };

  const seeOrderMap = (document) => {
    navigate(`/dashboard/map?document=${document}`);
  };

  const handleSubmit = async (data) => {
    formRef.current.setErrors({});
    const { payload, error } = await reasonForm(data);
    if (error) return formRef.current.setErrors(error);
    if (payload) {
      const result = {
        ...payload,
        orderStatus: order.orderStatus,
        document: order.document,
        deliveryForecast: payload.deliveryDate,
      };
      Reflect.deleteProperty(result, 'deliveryDate');
      if (result.deliveredDate === '')
        Reflect.deleteProperty(result, 'deliveredDate');
      api
        .post('/deliveryorder/delivery-order-confirmation', result)
        .then(async (e) => {
          const { message } = e.data;
          await dispatch(
            getPopup({
              message: message,
              type: 'success',
            }),
          );
          await dispatch(
            fetchOrders({
              url: '/deliveryorder/delivery-orders',
              method: 'GET',
            }),
          );
          closeModal();
        })
        .catch((err) => {
          dispatch(
            getPopup({
              message: err?.response?.data?.message || "Erro ao executar a ação",
              type: 'danger',
            }),
          );
        });
    }
  };

  return (
    <>
      <Animation>
        <MetaTitle title="Pedidos" />
        <Table
          data={dataUpdateObject}
          title="Gerenciamento de Pedidos"
          keyStorage="orders_filter"
          columns={[
            'document',
            'warehouseCode',
            'warehouse',
            'deliveryDate',
            'deliveredDate',
            'orderStatus',
          ]}
          advancedFilter={true}
          advancedFilterOptions={{
            orderStatus: [
              { label: 'Pedido Recebido', value: 'AAA' },
              { label: 'Pedido Recebido', value: 'CBA' },
              { label: 'Pedido em Conferência', value: 'CBB' },
              { label: 'Pedido em Trânsito', value: 'CCC' },
              { label: 'Pedido Entregue', value: 'APP' },
            ],
          }}
          columnNames={[
            'Documento',
            'Código Depósito',
            test()
              ? 'Depósito'
              : 'Centro de Distribuição',
            'Previsão de entrega',
            'Entrega realizada',
            'Status',
          ]}
          columnsModify={{
            orderStatus: (value) => {
              const orderType = {
                AAA: <Status typeName="warning">Pedido Recebido</Status>,
                CBA: <Status typeName="orange">Pedido Recebido</Status>,
                CBB: <Status typeName="danger">Pedido em Conferência</Status>,
                CCC: <Status typeName="welcome">Pedido em Trânsito</Status>,
                APP: <Status typeName="success">Pedido Entregue</Status>,
                default: value,
              };
              return orderType[value] || orderType['default'];
            },
            deliveryDate: (value) => (value === '01/01/1 00:00' ? '' : value),
            deliveredDate: (value) => (value === '01/01/1 00:00' ? '' : value),
          }}
          columnButtons={[
            (data) => (
              <Button typeName="welcome" onClick={() => seeOrder(data)}>
                Ver
              </Button>
            ),
            (data) => (
              <Button typeName="warning" onClick={() => editDelivery(data)}>
                Alterar
              </Button>
            ),
            ({ document, orderStatus, licensePlate }) => (
              <Button
                typeName="warning"
                onClick={() =>
                  (orderStatus === 'CCC' || licensePlate === null) &&
                  seeOrderMap(document)
                }
                disabled={orderStatus !== 'CCC' || licensePlate === null}
                cursor={
                  orderStatus !== 'CCC' || licensePlate === null
                    ? 'not-allowed'
                    : null
                }
                title={
                  orderStatus !== 'CCC' || licensePlate === null
                    ? 'Desabilitado'
                    : null
                }
              >
                Ver no mapa
              </Button>
            ),
          ]}
        />
      </Animation>
      <Modal open={toggle} openModal={closeModal}>
        <ContainerModal>
          <Title>
            {order?.document} - {order?.warehouseCode} - {order?.warehouse}
          </Title>
          <Form initialData={order} ref={formRef} onSubmit={handleSubmit}>
            <Input
              label="Previsão de entrega:"
              name="deliveryDate"
              type="date"
            />
            <Input
              label="Entrega realizada:"
              name="deliveredDate"
              type="date"
            />
            <ButtonContent>
              <Checkbox
                name="confirmed"
                defaultChecked={order?.orderStatus === 'APP'}
                label="Confirmar Recebimento"
              />
            </ButtonContent>
            <Textarea name="reason" label="Motivo: *" grid="1/-1" />
            <ButtonContent>
              <Button typeName="success">Enviar</Button>
              <Button typeName="welcome" type="button" onClick={closeModal}>
                Voltar
              </Button>
            </ButtonContent>
          </Form>
        </ContainerModal>
      </Modal>
    </>
  );
}
